/* globals Event */

import angular from 'angular';
import template from './app.html';
import { IS_TOUCH_DEVICE } from '../../constants';
import { STATES } from '../../constants/states';
import './app.global.css';
import { track, CLICK } from '@updater-core/lib/tracker';
import * as analytics from '../../state/analytics/analytics.actions';
import { attachIdentify } from '@updater-core/lib/optimizely';

class AppController {
  constructor($state, $element, updStore, $rootScope) {
    'ngInject';

    const { connect, dispatch } = updStore;

    Object.assign(this, {
      $state,
      $element,
      connect,
      dispatch,
      $rootScope,
    });
  }

  $onInit() {
    attachIdentify((...args) => this.dispatch(analytics.identify(...args)));

    const unsubscribe = this.$rootScope.$on(
      '$stateChangeSuccess',
      (_, toState) => {
        unsubscribe();

        // 🚨 HACK ALERT 🚨
        // Remove the app loading animation once we've entered our first state.
        // The home services step handles this itself when a subroute has loaded, and
        // the product intro page can potentially redirect to home services, so it handles this too
        if (
          toState.name !== STATES.NEW_PRODUCT_INTRO &&
          toState.name !== STATES.STEP_HOME_SERVICES_APP
        ) {
          this.$element[0].dispatchEvent(
            new Event('upd-app-loaded', { bubbles: true })
          );
        }
      }
    );

    // If this is a touch-enabled device we add an empty mouseover listener to the app,
    // only needed because of broken event delegation on iOS
    // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
    if (IS_TOUCH_DEVICE) {
      this.$element.on('mouseover', angular.noop);
    }

    this.trackLinkClicks = (event) => {
      if (!event.composedPath) return;

      const path = event.composedPath();
      const link = path.find((e) => e.tagName === 'A' && e.target === '_blank');

      if (!link) return;

      track({
        object: 'new_tab_link',
        verb: CLICK,
        details: {
          link: link.href,
          path: window.location.pathname,
        },
      });
    };
    this.$element[0].addEventListener('click', this.trackLinkClicks);
  }

  $onDestroy() {
    this.$element[0].removeEventListener('click', this.trackLinkClicks);
  }

  // Determine whether to hide the header or not
  // NOTE: To hide the header all you need to do is add a 'hideHeader' property on the state
  //       and set it to true.
  hideHeader() {
    return (this.$state.current || {}).hideHeader;
  }

  // Determine whether to hide the footer or not
  // NOTE: To hide the footer all you need to do is add a 'hideFooter' property on the state
  //       and set it to true.
  hideFooter() {
    return (this.$state.current || {}).hideFooter;
  }
}

export const AppComponent = {
  template,
  controller: AppController,
};
